import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Leagues from './pages/Leagues';
import BlindStructures from './pages/BlindStructures';
import Venues from './pages/Venues';
import Games from './pages/Games';
import GameDetails from './pages/GameDetails';
import Schedules from './pages/Schedules';
import Users from './pages/Users';
import UserProfile from './pages/UserProfile';
import UserEdit from './pages/UserEdit';
import Kiosk from './pages/Kiosk';
import Reports from './pages/Reports';
import DealerSchedule from './pages/DealerSchedule';
import Notifications from './pages/Notifications';
import Promotions from './pages/Promotions';
import Duplicates from './pages/Duplicates';
import Championship from './pages/Championship';
import Home from './pages/Home';
import Schedule from './pages/Schedule';
import { loadSession, saveSession, clearSession } from './utils/session';
import './App.css';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // Load session from localStorage on mount
  useEffect(() => {
    const restoreSession = () => {
      const savedUser = loadSession();
      if (savedUser) {
        setUser(savedUser);
        setIsLoggedIn(true);
      }
      setIsLoading(false);
    };

    restoreSession();
  }, []);

  const handleLogin = (userData) => {
    setUser(userData);
    setIsLoggedIn(true);
    saveSession(userData);
  };

  const handleLogout = () => {
    setUser(null);
    setIsLoggedIn(false);
    clearSession();
  };

  // Show loading state while checking session
  if (isLoading) {
    return (
      <div className="app" style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        background: 'linear-gradient(135deg, #0d1b2a 0%, #1b2a4a 100%)'
      }}>
        <div style={{
          color: 'white',
          fontSize: '1.5rem',
          textAlign: 'center'
        }}>
          <div>Loading...</div>
        </div>
      </div>
    );
  }

  return (
    <Router>
      <div className="app">
        <Routes>
          <Route
            path="/"
            element={
              !isLoggedIn ?
                <Login onLogin={handleLogin} /> :
                <Navigate to="/dashboard" />
            }
          />
          <Route
            path="/dashboard"
            element={
              isLoggedIn ?
                <Dashboard user={user} onLogout={handleLogout} /> :
                <Navigate to="/" />
            }
          />
          <Route
            path="/leagues"
            element={
              isLoggedIn ?
                <Leagues user={user} onLogout={handleLogout} /> :
                <Navigate to="/" />
            }
          />
          <Route
            path="/leagues/:leagueId/blind-structures"
            element={
              isLoggedIn ?
                <BlindStructures user={user} onLogout={handleLogout} /> :
                <Navigate to="/" />
            }
          />
          <Route
            path="/venues"
            element={
              isLoggedIn ?
                <Venues user={user} onLogout={handleLogout} /> :
                <Navigate to="/" />
            }
          />
          {/* Redirect old /locations route to /venues */}
          <Route
            path="/locations"
            element={<Navigate to="/venues" replace />}
          />
          <Route
            path="/schedules"
            element={
              isLoggedIn ?
                <Schedules user={user} onLogout={handleLogout} /> :
                <Navigate to="/" />
            }
          />
          <Route
            path="/games"
            element={
              isLoggedIn ?
                <Games user={user} onLogout={handleLogout} /> :
                <Navigate to="/" />
            }
          />
          <Route
            path="/games/:gameId"
            element={
              isLoggedIn ?
                <GameDetails user={user} onLogout={handleLogout} /> :
                <Navigate to="/" />
            }
          />
          <Route
            path="/notifications"
            element={
              isLoggedIn ?
                <Notifications user={user} onLogout={handleLogout} /> :
                <Navigate to="/" />
            }
          />
          <Route
            path="/dealer-schedule"
            element={
              isLoggedIn ?
                <DealerSchedule user={user} onLogout={handleLogout} /> :
                <Navigate to="/" />
            }
          />
          <Route
            path="/promotions"
            element={
              isLoggedIn ?
                <Promotions user={user} onLogout={handleLogout} /> :
                <Navigate to="/" />
            }
          />
          <Route
            path="/reports"
            element={
              isLoggedIn ?
                <Reports user={user} onLogout={handleLogout} /> :
                <Navigate to="/" />
            }
          />
          <Route
            path="/users"
            element={
              isLoggedIn ?
                <Users user={user} onLogout={handleLogout} /> :
                <Navigate to="/" />
            }
          />
          <Route
            path="/users/:userId/edit"
            element={
              isLoggedIn ?
                <UserEdit user={user} onLogout={handleLogout} /> :
                <Navigate to="/" />
            }
          />
          <Route
            path="/users/:userId"
            element={
              isLoggedIn ?
                <UserProfile user={user} onLogout={handleLogout} /> :
                <Navigate to="/" />
            }
          />
          <Route
            path="/duplicates"
            element={
              isLoggedIn ?
                <Duplicates user={user} onLogout={handleLogout} /> :
                <Navigate to="/" />
            }
          />
          <Route
            path="/championship"
            element={
              isLoggedIn ?
                <Championship user={user} onLogout={handleLogout} /> :
                <Navigate to="/" />
            }
          />
          <Route path="/home" element={<Home />} />
          <Route path="/schedule" element={<Schedule />} />
          <Route
            path="/kiosk"
            element={<Kiosk user={user} onLogin={handleLogin} onLogout={handleLogout} />}
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
